import { Component, ElementRef, OnInit, ViewChild, ViewChildren, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { ICheckbox, IColumnchooser, IColumnHiding, IColumns, IEditing, IExportExcel, IGridOptions, IScroll, ISearchPanel, ProductoServicio, Toolbar, UnidadMedida } from 'app/interfaces';
import { CoalService } from 'app/services/coal.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectOperacionState, selectPermisosState, selectUtilsState } from 'app/store/app.states';
//import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogNewCfdiComponent } from '../dialog-new-cfdi/dialog-new-cfdi.component';


@Component({
	selector: 'app-lista-importacion',
	templateUrl: './lista-importacion.component.html',
	styleUrls: ['./lista-importacion.component.scss'],
})
export class ListaImportacionComponent implements OnInit {

	typeFilter: boolean = true;
	tasaa = new FormControl([Validators.pattern]);
	private dataReportSubject: BehaviorSubject<any[]> = new BehaviorSubject<
		any[]
	>([]);
	public dataReport$ = this.dataReportSubject.asObservable();

	// unidades de medida
	unidadMedida: UnidadMedida[] = [];
	filteredUnidadMedida: Observable<UnidadMedida[]>;
	getStateOperacion: Observable<any>;

	options: ProductoServicio[] = [];
	filteredOptions: Observable<ProductoServicio[]>;
	// myControl = new FormControl();
	// myControlUnidadMedida = new FormControl();
	// @ViewChild('datosTabla1') datosTabla1: MatTable<PeriodicElement>;
	// @ViewChild('datosTabla2') datosTabla2: MatTable<PeriodicElement2>;
	delete: number;
	delete2: number;
	index: number = 0;
	index2: number = 0;

	gridOptions: IGridOptions;
	columns: IColumns[];
	exportExcel: IExportExcel;
	searchPanel: ISearchPanel;
	scroll: IScroll;
	toolbar: Toolbar[];
	columnHiding: IColumnHiding;
	Checkbox: ICheckbox;
	Editing: IEditing;
	Columnchooser: IColumnchooser;
	objetoGridConfiguration: any;
	objetosSelected: any;

	numeroPedimento: number = 0;
	nombre: string = '';
	tasa: number = 0
	monto: number = null
	typo: string = ''
	mostrar = true;
	lstIva: any;
	lstIva_retenido: any;
	lstIeps: any;
	lstIsr: any;

	idOperacion: number;
	ArrayImpuestosLocales = [];
	arreglo: any;
	a: any;
	lstDataReport = [];
	dataReport = [];
	idTipoReporteSel: number = 1;
	data: any;
	datosevent: any;
	verGrid: boolean = false;
	evento: any;
	idRoll = 2;
	mostrarControl = false;
	mostrarGrid = false;
	descargarExcel = true;
	displayedColumns: string[] = ['position', 'nombre', 'tasa', 'monto', 'typo'];
	dataSource1 = [{ position: '', nombre: '', tasa: 0, monto: 0, typo: '' }];

	displayedColumns2: string[] = ['position', 'nombre'];
	dataSource2 = [{ position: 0, numero_Pedimento: 0 }];

	mostrarAddCarga = false;
	contadorCargaMasiva = 0;
	lstTipoImpuesto: any;
	opcionSeleccionado = ''
	datosEventProducto: any;
	lstProducto: any = [];
	tituloFile
	arrayBuffer: any;
	spinner: boolean = false;
	dataActualizacion: any = [];
	modificarDatos: boolean = false;

	selectedTab = 0;
	rowsetshowClave: boolean = false;
	rowsetshowUnidad: boolean = false;
	mostrarIvaRet: boolean = false;
	errorNaN: boolean = false;
	isValidUnidad: boolean = true;
	isValidClave: boolean = true;
	nombreReporte: string = '';
	getStateUtils: Observable<AppState>;
	idEmpresa: any;
	configured: boolean = null;
	
	constructor(
		public dialog: MatDialog,
		private srvcoal: CoalService,
		private _snackBar: MatSnackBar,
		private router: Router,
		private store: Store,
	) {
		this.store.select(selectUtilsState).subscribe((state: any) => {
			if( state.empresaSeleccionada === undefined ){
				this.configured = false;
			}
			else{
				this.configured = true;
				if (this.idEmpresa !== state.empresaSeleccionada.id) {
					this.idEmpresa = state.empresaSeleccionada.id;
					this.GetData(1);
				}
			}
		});

		this.dataReport$.subscribe((nuevosDatos) => {
			this.dataReport = nuevosDatos;
		});
	}

	ngOnInit(): void {

		this.modificarDatos = false;
		this.selectedTab = 0;
		this.dataSource1 = [];
		this.dataSource2 = [];

	}

	newCfdi(info): void {
		const dialogRef = this.dialog.open(DialogNewCfdiComponent, {
			width: '800px',
			disableClose: true,
			data: { mode: 1, producto: null, idEmpresa: this.idEmpresa },
		});

		dialogRef.afterClosed().subscribe(result => {
			console.log('The dialog was closed', result);

			if (result.success == 1) {
				this.GetData(1);
				/*
				const productoExistente = this.dataReport.find(
					(producto) => producto.id === result.producto.id
				);
				if (productoExistente) {
					Object.assign(productoExistente, result.producto);
				} else {
					this.dataReport.push(result.producto);
				}
				this.dataReportSubject.next(this.dataReport);
				;*/

			}

		});
	}

	xlsxToJSON(event) {
		let fileReader = new FileReader();
		fileReader.readAsArrayBuffer(event);
		fileReader.onload = async (e) => {
			this.arrayBuffer = fileReader.result;
			let data = new Uint8Array(this.arrayBuffer);
			let arr = new Array();
			for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
			let bstr = arr.join("");
			let workbook = XLSX.read(bstr, { type: "binary" });
			let first_sheet_name = workbook.SheetNames[0];
			let worksheet = workbook.Sheets[first_sheet_name];
			let arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
			this.lstProducto = arraylist;
			this.lstProducto.array.forEach(x => {
				x.Nombre = x.Nombre.toUpperCase();
				x.Descripcion = x.Descripcion.toUpperCase();
			});
			this._snackBar.open("Carga de datos completa", 'Ok', { duration: 10000 });
			// this.spinner = false;
			//console.log('datos del excel', this.lstProducto)
		}
	}

	onSearchChange(value: any) {
		console.log("🚀 ~ onSearchChange ~ value:", value)

	}

	ObjectGrid() {
		let that = this;
		this.nombreReporte = 'Solicitudes';
		this.objetoGridConfiguration = {
			GridOptions: {
				paginacion: 20,
				pageSize: [
					'40',
					'60',
					'80',
					'100'
				]
			},
			ExportExcel: { enabled: true, fileName: 'Historico' },
			ColumnHiding: { hide: true },
			Checkbox: { checkboxmode: 'single' },
			Editing: { allowupdate: true, mode: 'cell' },
			Columnchooser: { columnchooser: true },
			SearchPanel: { visible: true, width: 200, placeholder: 'Buscar...', filterRow: true },
			Scroll: { mode: 'infinite' },
			Color: null,
			Detail: { detail: false },
			ToolbarDetail: null,
			ToolBox: [],
			Columns: [],
			Data: [],
			Columns1: [1],
			Data1: [],
			datosMessage(evento) {
				that.objetosSelected = evento.data;

			}
		};
		/*
				ToolBox: [
						
					{
						location: 'after',
						widget: 'dxButton',
						locateInMenu: 'auto',
						options: {
							width: 60,
							onClick: this.modificar.bind(this),
							icon: '../../../assets/icons/ver.png',
						},
						visible: false,
						name: 'simple'
					}, {
						location: 'after',
						widget: 'dxButton',
						locateInMenu: 'auto',
						options: {
							width: 60,
							icon: '../../../assets/icons/borrar.png',
							onClick: this.EliminarProducto.bind(this)
						},
						visible: false,
						name: 'simple'
					}
				],*/
		this.DataColumnsGrid();
	};

	receiveMessage($event) {
		try {
			this.evento = $event.event;
			// console.log("misDATOS",this.datosevent)
		} catch (error) {
			// this.Excepciones(error, 1);
		}
	}

	modificar(e) {
		/*
		// console.log( "modificar(e)", this.datosevent );
		const dialogRef = this.dialog.open(ProductoAddComponent, {
			width: '800px',
			disableClose: true,
			data: { mode: 2, producto: this.datosevent },
		});

		dialogRef.afterClosed().subscribe(result => {
			console.log("🚀 ~ dialogRef.afterClosed ~ result:", result)

			if (result?.success == 1) {
				const productoExistente = this.dataReport.find(
					(producto) => producto.id === result.producto.id
				);
				if (productoExistente) {
					Object.assign(productoExistente, result.producto);
				} else {
					this.dataReport.push(result.producto);
				}
				this.dataReportSubject.next(this.dataReport);
			}
		});
		*/
	}



	invocarEventoCliente(e): void {
		this.mostrarGrid = false;
		//console.log('e', e);
	}

	EliminarProducto(e) {
		/*
		const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea eliminar este registro?' });
		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				// console.log("console datos event",this.datosevent)
				this.store.dispatch(MostrarSpinner())
				let idProducto = this.datosevent.id

				this.srvcoal.deleteService(`pro-productos/`, idProducto).subscribe(
					(res: any) => {
						if (res.err) {
							this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
						}
						else {
							const productoIndex = this.dataReport.findIndex(producto => producto.id === idProducto);
							this.dataReport.splice(productoIndex, 1);
							this._snackBar.open("Se ha eliminado con exito", 'ok', { duration: 3000 });
							this.store.dispatch(OcultarSpinner());;
						}
					}, (error: any) => {
						this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
						this.store.dispatch(OcultarSpinner());
						this.spinner = false;
					}
				);
			} else {
				this._snackBar.open('Eliminacion cancelada', 'OK', { duration: 3000 });
				//this.store.dispatch(OcultarSpinner());;
				this.spinner = false;
			}
		});
		*/

	}

	DataColumnsGrid() {
		if (!this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel)) {
			let columnsMulti = [];
			columnsMulti.push({
				caption: 'Código Solicitud SAT',
				dataField: 'solicitud',
				allowEditing: false,
				fixed: true,
			});
			columnsMulti.push({
				caption: 'Estatus',
				dataField: 'estatus',
				allowEditing: false
			});
			columnsMulti.push({
				caption: 'UUID',
				dataField: 'folio',
				allowEditing: false
			});
			columnsMulti.push({
				caption: 'Fecha Inicio',
				dataField: 'fechaInicial',
				allowEditing: false
			});
			columnsMulti.push({
				caption: 'Fecha Fin',
				dataField: 'fechaFinal',
				allowEditing: false
			});
			columnsMulti.push({
				caption: 'RFC Receptor',
				dataField: 'rfcReceptor',
				allowEditing: false
			});
			columnsMulti.push({
				caption: 'Fecha Solicitud',
				dataField: 'fechaSolicitud',
				allowEditing: false,
			});
			// columnsMulti.push({
			//   caption: 'Acciones',
			//   dataField: 'accion',
			//   allowEditing: false,
			//   cellTemplate: 'templateBotones'
			// });
			setTimeout(() => this.lstDataReport.push({
				idTipoReporte: this.idTipoReporteSel,
				columnas: columnsMulti,
				dataReport: this.dataReport,
				identificadorGrid: 0
			}), 500);
			setTimeout(() => this.FillGrid(), 800);
		} else {
			this.FillGrid();
		}
	}

	FillGrid() {
		this.objetoGridConfiguration.Columns = this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel && x.identificadorGrid === 0).columnas;
		this.objetoGridConfiguration.Data = this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel && x.identificadorGrid === 0).dataReport;
		this.verGrid = true;
		this.store.dispatch(OcultarSpinner());
	}

	datosMessage($event) {
		try {
			console.log("soy", $event.data[0])
			this.datosevent = $event.data[0];
		} catch (error) {
			// this.Excepciones(error, 1);
		}
	}

	Excepciones(pila, tipoExcepcion: number) {
		try {
			const dialogRef = this.dialog.open(ExcepcionesComponent, {
				width: '60%',
				data: {
					idTipoExcepcion: tipoExcepcion,
					idUsuario: 1,
					idOperacion: 1,
					idAplicacion: 1,
					moduloExcepcion: 'sel-caja-historial.component',
					mensajeExcepcion: '',
					stack: pila,
				},
			});
			dialogRef.afterClosed().subscribe((result: any) => { });
		} catch (error) {
			// console.error(error);
		}
	}

	getErrorMessage() {
		if (this.tasaa.hasError('pattern')) {
			return 'You must enter a value';
		}
		return 'You must enter a value';
	}

	cargaMasiva() {
		this.router.navigate(['/catalogos/carga-masiva-productos']);
	}

	GetData(param: number) {
		this.store.dispatch(MostrarSpinner());
		this.verGrid = false;
		this.dataReport.length = 0;
		this.lstDataReport.length = 0;
		// this.spinner = true;
		let baseUrl = '';//`tar-recuperaciones?populate=*`;
		let filters = [];

		// Verifica si `param.frmPago` está definido y no es nulo
		// if (param.formaPago) {
		// 	filters.push(`filters[cat_metodo_pago][id][$eq]=${param.formaPago}`);
		// }

		baseUrl = `ope-empresas/?populate[tar_recuperacions][populate]=*&filters[id]=${this.idEmpresa}`;

		if (param == 1) {
			this.typeFilter = true;
			//baseUrl = `ope-empresas/?populate[tar_recuperacions][populate]=*&filters[id]=${this.idEmpresa}`;
			//baseUrl = 'tar-recuperaciones?filters[cat_tarea_estatus]=1&populate=*';
		}

		if (param == 2) {
			this.typeFilter = false;
			//baseUrl = `ope-empresas/?populate[tar_recuperacions][populate]=*&filters[id]=${this.idEmpresa}`;
			//baseUrl = 'tar-recuperaciones?filters[cat_tarea_estatus]=3&populate=*';
		}

		this.srvcoal.getService(baseUrl).subscribe(async (res: any) => {
			if (res.err) {
				this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
			} else {

				let dataArray: any[] = [];
				let data: any[] = res?.data ? res.data : [];
				let infoArray: any[] = [];
				if (data.length > 0) {
					let info = data[0]?.attributes ? data[0]?.attributes?.tar_recuperacions : {};
					infoArray = info?.data ? info.data : [];
				}
				console.log("🚀 ~ ListaImportacionComponent ~ forawait ~ element:", infoArray)
			
					for await (const element of infoArray) {

						const datos = {
							folio: element?.attributes?.uuid ? element.attributes.uuid : '',
							rfcReceptor: element?.attributes?.rfcReceptor ? element.attributes.rfcReceptor : '',
							fechaInicial: element?.attributes?.fechaInicial ? element.attributes.fechaInicial : '',
							fechaFinal: element?.attributes?.fechaFinal ? element.attributes.fechaFinal : '',
							fechaSolicitud: element?.attributes?.createdAt ? element.attributes.createdAt : '',
							//Estatus
							estatusId: element?.attributes?.cat_tarea_estatus?.data ? element.attributes.cat_tarea_estatus.data.id : 0,
							estatus: element?.attributes?.cat_tarea_estatus?.data ? element.attributes.cat_tarea_estatus.data.attributes.estatus : '',
							//Tipo de comprobante
							tipoFactura: element?.attributes?.cat_tipo_comprobante?.data ? element.attributes.cat_tipo_comprobante.data.id : 0,
							tipoFactura_nombre: element?.attributes?.cat_tipo_comprobante?.data ? element.attributes.cat_tipo_comprobante.data.attributes.nombre : '',

							//recuperacion respuesta
							idSolicitud: element?.attributes?.tar_recuperacion_respuesta?.data ? element.attributes.tar_recuperacion_respuesta.data.id : 0,
							solicitud: element?.attributes?.tar_recuperacion_respuesta?.data ? element.attributes.tar_recuperacion_respuesta.data.attributes.idSolicitud : null,

						}
						//Add data...
						dataArray.push(datos);
					}//Fin array

					//Set Filter
					// Estatus catálogo: 1=PROCESO, 2=EJECUCION, 3=FINALIZADA, 4=ERROR
					if (dataArray.length > 0) {
						if (param == 1) {
							// Tab "En Proceso": solicitudes en PROCESO o EJECUCION
							this.dataReport = dataArray.filter(x => x.estatusId == 1 || x.estatusId == 2);
							this.typeFilter = true;
						} else {
							// Tab "Terminados": FINALIZADA o ERROR
							this.dataReport = dataArray.filter(x => x.estatusId == 3 || x.estatusId == 4);
							this.typeFilter = false;
						}
					} else {
						this.dataReport = [];
					}

					this.ObjectGrid();
				}
			
		}, (error: any) => {
			console.log("erro *************** 3", error)
			this.store.dispatch(OcultarSpinner());
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))

		});

	}
}
